import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import styled from '@emotion/styled';

import HamburgerMenu from './HamburgerMenu/HamburgerMenu';
import Header from './Header/Header';

const LayoutPage = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <HamburgerMenu
        open={open}
        toggleNav={() => {
          setOpen(!open);
        }}
      />
      <Header
        open={open}
        toggleNav={() => {
          setOpen(!open);
        }}
      />
      <Main>
        <Outlet />
      </Main>
    </>
  );
};

export default LayoutPage;

const Main = styled.main`
  display: flex;
  /* border: 2px solid red; */

  @media (max-width: 480px) {
    margin: 0 1.25rem;
  }
`;
